<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : snRule.pkid ? '编辑' : '新建'"
      width="1000px"
      class="adaptationModal"
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="snRule"
        :rules="ruleValidate"
        class="form"
        :disabled="disabled"
        label-width="80px"
    >
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="snRule.pkid" :span="12">
          <el-form-item label="标签编号" prop="materialSnRuleNo">
            <el-input v-model="snRule.materialSnRuleNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料编号" prop="materialNo">
            <el-input v-model="snRule.materialNo" placeholder="请选择物料" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectMaterial.open()"/>
            </el-input>
            <material-select ref="selectMaterial" @select="selectMaterial"/>
          </el-form-item>
        </el-col>
        <el-col v-if="snRule.materialNo" :span="12">
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model="snRule.materialName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="snRule.materialNo" :span="12">
          <el-form-item label="版本号">
            <el-input v-model="snRule.snVersion" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="条码规则" prop="snRuleNo">
            <el-input v-model="snRule.snRuleNo" placeholder="请选择条码规则" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectSnRule.open()"/>
            </el-input>
            <bar-code-rules-select ref="selectSnRule" @select="selectSnRule"/>
          </el-form-item>
        </el-col>
        <el-col v-if="snRule.snRuleNo" :span="12">
          <el-form-item label="条码样式">
            <el-input v-model="snRule.snRuleExpression" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-select v-model="snRule.status" placeholder="请选择状态" clearable>
              <el-option label="待确认" :value="10"/>
              <el-option label="已确认" :value="20"/>
              <el-option label="已作废" :value="90"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">标签信息</div>
      <el-button type="primary" style="margin-bottom: 8px" @click="$refs.materialSnRuleDetailsEdit.open()"> 添加 </el-button>
      <Table border :columns="columns" :data="snRule.snMaterialSnRuleDetailList">
        <template slot="action" slot-scope="{ index }">
          <el-button type="danger" @click="snRule.snMaterialSnRuleDetailList.splice(index, 1)">删除</el-button>
        </template>
      </Table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <material-sn-rule-details-edit ref="materialSnRuleDetailsEdit" @save-success="getTagInfo"/>
  </el-dialog>
</template>

<script>
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import BarCodeRulesSelect from "@/views/information/BarCodeRules/BarCodeRulesSelect";
  import MaterialSnRuleDetailsEdit from "./MaterialSnRuleDetailsEdit";
  export default {
    components: {
      MaterialSelect,
      BarCodeRulesSelect,
      MaterialSnRuleDetailsEdit,
    },
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        snRule: {
          pkid: 0,
          materialSnRuleNo: "",
          materialName: "",
          materialNo: "",
          materialId: "",
          snRuleNo: "",
          snRuleId: "",
          snRuleExpression: "",
          snVersion: "",
          status: "",
          snMaterialSnRuleDetailList: [],
        },
        ruleValidate: {
          materialNo: { required: true, message: "请选择物料信息", trigger: "change" },
          snRuleNo: { required: true, message: "请选择条码规则", trigger: "change" },
          status: { required: true, message: "请选择条码规则", trigger: "change" },
        },
        columns: [
          {
            title: "标签编号",
            key: "metaDataNo",
            width: 100,
            align: "center",
          },
          {
            title: "标签描述",
            key: "metaDataDesc",
            minWidth: 300,
          },
          {
            title: "值",
            key: "metaDataValue",
            width: 160,
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = !!mark;
        if (row) {
          this.getData(row.pkid);
        }
      },

      getData(pkid) {
        this.contentLoading = true;
        this.$http
          .get("basic", `snMaterialSnRules/${pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.snRule = Object.assign(this.snRule, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      selectMaterial(row) {
        console.log(row);
        this.snRule.materialId = row.id;
        this.snRule.materialNo = row.no;
        this.snRule.materialName = row.name;
        this.getVersionByMetrailId();
      },

      getVersionByMetrailId() {
        this.$http.get("basic", `snMaterialSnRules/version?materialId=${this.snRule.materialId}`).then((resp) => {
          if (resp.success) {
            this.snRule.snVersion = resp.data;
          }
        });
      },

      selectSnRule(row) {
        this.snRule.snRuleNo = row.snRuleNo;
        this.snRule.snRuleId = row.pkid;
        this.snRule.snRuleExpression = row.snRuleExpression;
      },

      getTagInfo(row) {
        this.snRule.snMaterialSnRuleDetailList.push(row);
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.snRule.snMaterialSnRuleDetailList.length) {
              this.$confirm("标签信息不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
            } else {
              this.submitLoading = true;
              this.$http
                .save("basic", "snMaterialSnRules", this.snRule)
                .then((resp) => {
                  if (resp.success) {
                    if (this.snRule.pkid) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                    } else {
                      this.$emit("save-success");
                      this.$message.success("添加成功");
                    }
                  }
                  this.submitLoading = false;
                  this.dialogVisible = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>
